let $ = require("jquery");
import run from '../../utilities/run';
import render from "../../utilities/render";
import {isFalsey, isBlank} from '../../utilities/general'
import {setElementsFromScope} from '../../utilities/selectorHelpers';
import {bindHardSubmit} from "../../utilities/submitHelpers";
const famfAcctNumberBlockTemplate = require("./html/famfAcctNumberBlock.html");
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

const elementsPageMap = {
  addProductBtn: '#find-rma-item',
  addFedexAccntBtn: '.add-fedex-acct-btn2',
  fedexAccoutsContainer: ".fedex-accounts-container",
  fedexAccntBlock: ".fedex-acct-block",
  fedexAccntNumber: ".fedex-acct-number",
  smartPostAccntNumber: ".smartpost-acct-number",
  smartPostHubIdOptions: ".smartpost-hub-id-options",
  editFedexAccountsBtn: ".edit-fedex-accounts-btn",
  fedexAccountsForm: "#fedex-accounts-management-form",
  fedexAccountsDetailPage: ".fedex-accounts-detail-page",
  hasCorrespondingSmartPost: "#ret-require-smartpost",
  singleAcctNumHubIdDupDiv: ".single-acctNum-hubId-dup-div",
  multipleAcctNumHBIdDupDiv:".multiple-acctNum-hubId-dup-div",
  singleAcctNumHubIdDupErrMsg:"#single-acctNum-hubId-dup-error",
  multipleAcctNumHubIdDupErrMsg : "#multiple-acctNum-hubId-dup-error"
};

export default function FamfLogic(mainEl){
  const isHoneyCombUser = $(elementsPageMap.fedexAccountsDetailPage).data("is-honey-comb-user");

  const self = this;
  const elsPage = {};
  const elsModals = {};

  self.init = function() {
    setElements();
    bindElements();
    requireSmartpostState();
  };

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
  }

  function bindElements() {
    elsPage.addFedexAccntBtn.on("click", addAdditionalAccounts);
    elsPage.hasCorrespondingSmartPost.on("change", requireSmartpostState);
  }

  function addAdditionalAccounts() {
      const fedexAccountsTemplate = $(famfAcctNumberBlockTemplate);
      let fedexAccntBlockSize = elsPage.fedexAccoutsContainer.find(".fedex-acct-block").length;
      let fedexAccntBlockIdSize = elsPage.fedexAccoutsContainer.find(".fedex-acct-block").length + 1;

      let accntNumber = fedexAccountsTemplate.find('.fedex-acct-number');
      accntNumber.attr('name','fedexAccounts['+fedexAccntBlockSize+'].cmtAccountNumber');
      accntNumber.attr('id','fedex-acct-number-'+fedexAccntBlockIdSize);
      let accntNumberHiddenId = fedexAccountsTemplate.find('.fedex-accnt-hidden-id');
      accntNumberHiddenId.attr('name','fedexAccounts['+fedexAccntBlockSize+'].cmtId');

      let smartPostAccntNumber = fedexAccountsTemplate.find('.smartpost-acct-number');
      smartPostAccntNumber.attr('name','fedexAccounts['+fedexAccntBlockSize+'].cmtHubId');
      smartPostAccntNumber.attr('id','smartpost-hub-id-'+fedexAccntBlockIdSize);
      smartPostAccntNumber.select2();
      addOptionsToSmartPostHub(smartPostAccntNumber);

      elsPage.fedexAccoutsContainer.append(fedexAccountsTemplate);
      requireSmartpostState();
  }

  function addOptionsToSmartPostHub(smartPostAccntNumber) {
      const smartPostHubIdOptionsVar  =  elsPage.smartPostHubIdOptions.data('options');
      $(smartPostHubIdOptionsVar).each(function(){
    					 var option = $('<option />');
    					 option.attr('value', this.cdmValue).text(this.cdmDescription);
    					 smartPostAccntNumber.append(option);
    	});
  }

  bindHardSubmit({
      form: $(elementsPageMap.fedexAccountsForm),
      links: $(elementsPageMap.editFedexAccountsBtn)
  });

  $(elementsPageMap.fedexAccountsForm).validate({
      errorPlacement: function(error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      },
  });

  $(elementsPageMap.fedexAccountsForm).on("submit", function(e) {
    e.preventDefault();
    let hubIdArray = [];
    let uniqueHubIdArray = [];
    if (mainEl.valid()) {
      if (isHoneyCombUser === "HONEYCOMB_RMS") {
        elsPage.singleAcctNumHubIdDupDiv.hide();
        elsPage.multipleAcctNumHBIdDupDiv.hide();
        for (let i = 0; i <= $("option:selected").length; i++) {
          for (j = i + 1; j < $("option:selected").length; j++) {
            if ($("option:selected")[i].value === $("option:selected")[j].value) {
              if ($("input[type='text']")[i].value === $("input[type='text']")[j].value) {
                hubIdArray.push($("option:selected")[i].value);
              }
            }
          }
        }
        $.each(hubIdArray, function(i, el) {
          if ($.inArray(el, uniqueHubIdArray) === -1) uniqueHubIdArray.push(el);
        });
        if (uniqueHubIdArray.length === 1) {
          elsPage.singleAcctNumHubIdDupErrMsg.text(uniqueHubIdArray);
          elsPage.singleAcctNumHubIdDupDiv.show();
          return false;
        } else if (uniqueHubIdArray.length > 1) {
          elsPage.multipleAcctNumHubIdDupErrMsg.text(uniqueHubIdArray);
          elsPage.multipleAcctNumHBIdDupDiv.show();
          return false;
        }
      }
      const submitModalFlow = new SubmitModalFlow({
        confirmModalTitle: "Edit Fedex Accounts",
        confirmModalBody:
          '<div class="q-pad-all-xl">By submitting this configuration, the service configuration information will be saved for current retailer.</div>',
        confirmModalBtnText: "Submit",
        onConfirmClick: function() {
          submitModalFlow.showLoadingModal();
          let formData = $(elementsPageMap.fedexAccountsForm).serialize();
          $.ajax({
            url: mainEl.attr("action"),
            type: "POST",
            data: formData,
            success: function(resp) {
              submitModalFlow.showSuccessModal();
              setTimeout(function() {
                location.href = $(
                  elementsPageMap.fedexAccountsDetailPage
                ).data("fedex-accounts-detail-page-uri");
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            },
            error: function(error) {
              // TODO: error modal displaying from all.js file, so commenting show error modal code here!
              //submitModalFlow.showFailureModal();
            }
          });
        }
      });
      submitModalFlow.init();
      submitModalFlow.showConfirmModal();
    }
  });

  $("body").on("click", ".remove-fedex-acct-block-btn", function(e) {
      e.preventDefault();
      var fedexAcctBlock = $(this).closest(".fedex-acct-block");
      fedexAcctBlock.remove();
  });

  function requireSmartpostState() {
      var ifSmartpostReq = $(".if-smartpost-required");
      if(elsPage.hasCorrespondingSmartPost.is(":checked")){
          ifSmartpostReq.show();
      } else {
          ifSmartpostReq.hide();
          $(".smartpost-acct-number").val("").trigger("change.select2");
      }
  };
};



// WEBPACK FOOTER //
// ./src/pages/fedexAccountManagement/famfLogic.js